export default __webpack_public_path__ + "static/media/quotes.43fde1e0.svg";